"use client";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTrigger,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import Image from "next/image";
import { ReactNode, useEffect, useState } from "react";
import aboutus from "@/public/images/aboutus.jpg";
import logo from "@/public/images/smallLogo.png";
import { DialogClose } from "@radix-ui/react-dialog";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import OtherServicesData from "./OtherServicesData";
import { useTranslate } from "@/components/base/providers/TranslateProv";
import { useGetServcesQuery } from "@/redux/features/api/Consultation/consultationApiSlice";

interface Props {
  children: ReactNode;
}

interface Item {
  id: number;
  name: string;
}

const OtherServices = ({ children }: Props) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [otherServices, setOtherServices] = useState("");

  const { data: items } = useGetServcesQuery({});

  const handleCheckboxChange = (id: number) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
  };

  const { locale }: { locale: "ar" | "en" } = useTranslate();

  const translations = {
    en: {
      title: "Book a Consultation with 'University Ambassador'",
      description:
        "Specify your needs for the consultation as the price is determined based on that.",
      selectService: "Choose Your Special Service!",
      otherService: "Other Service",
      otherServicePlaceholder: "Your message",
      costInfo:
        "The cost is determined after selecting the service and reviewing the fees set for it.",
    },
    ar: {
      title: "احجز استشاره مع “سفير الجامعات”",
      description:
        "حدد الحاجات الـ محتجها في الاستشاره الخاصه بيك لان بناء عليها بيتم تحديد السعر",
      selectService: "اختار خدمتك الخاصة!",
      otherService: "خدمة اخري",
      otherServicePlaceholder: "الرساله الخاص بك",
      costInfo: "التكلفة تحدد بعد تحديد الخدمة والاطلاع الى الرسوم المقررة لها",
    },
  };

  const t = translations[locale];

  return (
    <>
      <Dialog>
        <DialogTrigger asChild className="w-full ">{children}</DialogTrigger>
        <DialogContent className="overflow-y-auto overflow-x-hidden max-h-screen ">
          <DialogHeader>
            <div className="relative mx-auto">
              <Image
                src={aboutus}
                alt="aboutus"
                className="rounded-full w-28 h-28 object-cover"
              />
              <Badge className="absolute -top-4 -right-[8px] bg-transparent">
                <Image src={logo} alt="logo" className="w-9" />
              </Badge>
            </div>
            <DialogDescription asChild>
              <div className="my-2">
                <DialogTitle className="text-darkText text-center font-semibold text-[18px] leading-[150%] w-full">
                  {t.title}
                </DialogTitle>
                <p className="text-darkText text-center font-medium text-[14px] leading-[200%] mt-2">
                  {t.description}
                </p>

                <div className="border border-gray-200 rounded p-2 mt-4">
                  <h3 className="text-darkText font-medium text-10 leading-normal mb-2 mx-2 border-b pb-2">
                    {t.selectService}
                  </h3>

                  <div>
                    {items?.data.map((item: any) => (
                      <div
                        key={item.id}
                        className="flex items-center gap-2 mb-2"
                      >
                        <Checkbox
                          id={`checkbox-${item.id}`}
                          checked={selectedIds.includes(item.id)}
                          onCheckedChange={() => handleCheckboxChange(item.id)}
                        />
                        <Label
                          htmlFor={`checkbox-${item.id}`}
                          className="text-sm"
                        >
                          {item.title[locale]}
                        </Label>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="border border-gray-200 rounded p-2 mt-4">
                  <h3 className="text-darkText font-medium text-10 leading-normal mb-2 mx-2 border-b pb-2">
                    {t.otherService}
                  </h3>

                  <div>
                    <textarea
                      value={otherServices}
                      onChange={(e) => setOtherServices(e.target.value)}
                      name={"message"}
                      className="w-full h-32 p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                      placeholder={t.otherServicePlaceholder}
                    />
                  </div>
                </div>
                <div className="flex mt-8">
                  <div className="w-full">
                    <p className="text-center mb-3 text-[#1F0570]">
                      {t.costInfo}
                    </p>
                    <OtherServicesData
                        otherServices={otherServices}
                        selectedIds={selectedIds}
                      >
                        <button
                          disabled={selectedIds.length === 0}
                          className={`${
                            selectedIds.length === 0 &&
                            "cursor-not-allowed opacity-40"
                          }  bg-primaryColor text-16 text-white font-[500] flex items-center justify-center rounded-[10px] h-[50px] w-full`}
                        >
                          {selectedIds.length === 0
                            ? locale == "ar"
                              ? "اختر الخدمات اولا"
                              : "Select services first"
                            : locale == "ar"
                            ? "طلب حجز الخدمه"
                            : "Request to book the service"}
                        </button>
                      </OtherServicesData>
                  </div>
                </div>
              </div>
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>

      {/* {isModalOpen && !isLoggedIn && <LoginFirst />} */}
    </>
  );
};

export default OtherServices;
